import script from "./PeopleModule.vue?vue&type=script&setup=true&lang=js"
export * from "./PeopleModule.vue?vue&type=script&setup=true&lang=js"

import "./PeopleModule.vue?vue&type=style&index=0&id=2eed19f8&lang=scss"

const __exports__ = script;

export default __exports__